import { createContext, useContext } from 'react';

interface FormSubmissionState {
  isSubmitting: boolean;
}

export const FormSubmissionStateContext = createContext<FormSubmissionState>({
  isSubmitting: false,
});

export function useFormSubmissionState() {
  return useContext(FormSubmissionStateContext);
}
